import { SipOtherAssignment } from "../../model/sipOtherAssignment";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipOtherAssignment;

type fetchResponseType = {
  data?: DtoType;
  error?: string;
};

export type TransformedDataType = DtoType;

export type GuiResponseType = {
  data?: TransformedDataType;
  error?: string;
};

export async function getSipOtherAssignments(
  sipOtherAssignmentId: string
): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getSipOtherAssignments.replace(
      "{{id}}",
      sipOtherAssignmentId
    );
    const response: fetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = response.data;

      console.log("API getSipOtherAssignments GUI: %o", xResponseData);
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipOtherAssignments: %o", err);
    return { error: (err as Error).message };
  }
}
